import pathfinder from '@fiverr-private/pathfinder';

export interface CategoryLink {
    title: string;
    href: string;
    badge?: string;
}

export const CATEGORY_LINKS_DEFAULT: CategoryLink[] = [
    {
        title: 'Website development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'Architecture & interior design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'architectural-design-services' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'Video editing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'video-editing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'Social media marketing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'online-marketing', id: 'social-marketing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'Presentation design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'presentations-design' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'Mobile app development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'mobile-app-services' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'popular',
    },
    {
        title: 'Book design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'book-design' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'AI development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'ai-coding' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'trending',
    },
];

export const CATEGORY_LINKS_V16: CategoryLink[] = [
    {
        title: 'Website development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'Book publishing',
        href: pathfinder(
            'content_pages_page',
            { page_slug: 'books-publishing' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'popular',
    },
    {
        title: 'Social media marketing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'online-marketing', id: 'social-marketing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'AI development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'ai-coding' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'trending',
    },
];

export const BRANDED_CATEGORY_LINKS: CategoryLink[] = [
    {
        title: 'website development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'architecture & interior design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'architectural-design-services' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'video editing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'video-editing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'social media marketing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'online-marketing', id: 'social-marketing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'presentation design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'presentations-design' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'mobile app development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'mobile-app-services' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'popular',
    },
    {
        title: 'book publishing',
        href: pathfinder(
            'content_pages_page',
            { page_slug: 'books-publishing' },
            { query: { source: 'category_tree' } }
        ),
    },
    {
        title: 'AI development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'ai-coding' },
            { query: { source: 'category_tree' } }
        ),
        badge: 'trending',
    },
];
